import React from "react";
import { Link, useLocation } from "react-router-dom";

const AdminSideMenu = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <aside className="modern-admin-sidebar">
      <div className="sidebar-content">
        {/* Dashboard Section */}
        <div className="sidebar-section">
          <h3 className="sidebar-section-title">Dashboard</h3>
          <ul className="sidebar-menu">
            <li>
              <Link
                to="/dashboard"
                className={`sidebar-menu-item ${
                  isActive("/dashboard") ? "active" : ""
                }`}
              >
                <span className="menu-icon">📊</span>
                <span className="menu-text">Dashboard</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Invoices Section */}
        <div className="sidebar-section">
          <h3 className="sidebar-section-title">Invoices</h3>
          <ul className="sidebar-menu">
            <li>
              <Link
                to="/invoices"
                className={`sidebar-menu-item ${
                  isActive("/invoices") ? "active" : ""
                }`}
              >
                <span className="menu-icon">📄</span>
                <span className="menu-text">Invoices</span>
              </Link>
            </li>
            <li>
              <Link
                to="/credit-notes"
                className={`sidebar-menu-item ${
                  isActive("/credit-notes") ? "active" : ""
                }`}
              >
                <span className="menu-icon">📋</span>
                <span className="menu-text">Credit Notes</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Stores Section */}
        <div className="sidebar-section">
          <h3 className="sidebar-section-title">Stores</h3>
          <ul className="sidebar-menu">
            <li>
              <Link
                to="/stores"
                className={`sidebar-menu-item ${
                  isActive("/stores") ? "active" : ""
                }`}
              >
                <span className="menu-icon">🏪</span>
                <span className="menu-text">Manage Stores</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Analytics Section */}
        <div className="sidebar-section">
          <h3 className="sidebar-section-title">Analytics</h3>
          <ul className="sidebar-menu">
            <li>
              <Link
                to="/analytics"
                className={`sidebar-menu-item ${
                  isActive("/analytics") ? "active" : ""
                }`}
              >
                <span className="menu-icon">📈</span>
                <span className="menu-text">Signing Analytics</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Settings Section */}
        <div className="sidebar-section">
          <h3 className="sidebar-section-title">Settings</h3>
          <ul className="sidebar-menu">
            <li>
              <Link
                to="/profile"
                className={`sidebar-menu-item ${
                  isActive("/profile") ? "active" : ""
                }`}
              >
                <span className="menu-icon">👤</span>
                <span className="menu-text">Profile</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default AdminSideMenu;
